import * as Yup from 'yup';
import { t } from 'i18next';

export const StatusSelectSchema = () => Yup.object().shape({
    statusSelect: Yup.string()
        .required(t('validation.required')),
});
